module.exports = __webpack_public_path__ + "static/2-275a82a17f04eb989bd3a89847e41323.jpg";